<div class="container-fluid">
  <div class="row pt-3">
    <div class="col-md-4">
      <p>Logging on gateway: <span class="badge ms-2" [ngClass]="{'text-bg-success': loggingOnGateway, 'text-bg-dark': !loggingOnGateway}"> {{loggingOnGateway ? 'On' : 'Off'}}</span></p>
      <p>Logging on meter: <span class="badge ms-2" [ngClass]="{'text-bg-success': deviceData.logging_period > 0, 'text-bg-dark': !deviceData.logging_period}"> {{deviceData.logging_period > 0 ? 'On' : 'Off'}}</span></p>
      <p>Datalogger status: <span class="badge ms-2" [ngClass]="{'text-bg-success': device.isOnline, 'text-bg-dark': !device.isOnline}"> {{device.isOnline ? 'Online' : 'Offline'}}</span></p>
    </div>
    <div class="col-md-4">
      <p>
        Data logging period:
        <span class="ms-2 fw-bold" [class.text-muted]="!device.isOnline">{{deviceData.logging_period ? deviceData.logging_period+' sec' : 'N/A'}}</span>
      </p>
      <p>
        Data push to server period: <span class="ms-2 fw-bold" [class.text-muted]="!device.isOnline">{{deviceData.push_period ? deviceData.push_period+' min' : 'N/A'}}</span>
      </p>
    </div>
    <div class="col-md-4">
      <p class="text-end"><button type="button" mat-raised-button color="accent" (click)="onClickAdhocBtn()"><mat-icon>publish</mat-icon> Push data</button></p>
    </div>
  </div>
</div>

@if (isAdmin) {
  <div class="mt-5">
    <mat-toolbar class="small-bar">
      <span>Status 3F</span>
      <span class="toolbar-spacer"></span>
      <button color="primary" mat-raised-button (click)="onClick3fBtn()"><mat-icon>sync</mat-icon> Get 3f status info</button>
    </mat-toolbar>
    @if (!status3f) {
      <p class="p-2 text-center">No data</p>
    }
    @if (status3f) {
      <table class="table table-sm table-bordered status3ftable">
        <thead>
          <tr>
            <th></th>
            @for (stat of status3f; track stat) {
              <th>{{stat.name}}</th>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>L1</p>
              <p>L2</p>
              <p>L3</p>
            </td>
            @for (stat of status3f; track stat) {
              <td>
                @for (val of stat.values; track val) {
                  <p>{{val|number:'1.0-2'}}</p>
                }
              </td>
            }
          </tr>
        </tbody>
      </table>
    }
  </div>
}

<div class="mt-3">
  <mat-toolbar class="small-bar">
    <span>Logging configs</span>
    <span class="toolbar-spacer"></span>
    <button class="ms-auto" (click)="confirmPurge()" mat-raised-button color="warn"><mat-icon>remove_circle</mat-icon> Delete all logging information</button>
    <button color="primary" class="ms-2" mat-raised-button (click)="onClickMeasure()"><mat-icon>add</mat-icon> Add logging config</button>
    <button class="ms-2" (click)="getMeasureStatus()" mat-raised-button color="primary"><mat-icon>sync</mat-icon> Check logging information</button>
  </mat-toolbar>

  @if (!measureRegisters) {
    <p class="p-2 text-center">No data</p>
  }
  @if (measureRegisters) {
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Index</th>
          <th>Measure name</th>
          <th>Register type</th>
          <th>Data type</th>
          <th>Data lenght</th>
          <th>Query</th>
          <th>Query Result</th>
          <th>Logging</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for (row of measures; track row; let idx = $index) {
          <tr>
            <td class="text-center">
              <app-register-popover [index]="idx+1" [registers]="row.registers"></app-register-popover>
            </td>
            <td>{{row.measureName}} [{{row.unit}}] {{row.registers && row.registers.length === 4 && row.registers[3].value ? ' + ' + row.registers[3].value : ''}}</td>
            <td>
              <div>
                @switch (row.counter) {
                  @case (0) {
                    <span>Instant</span>
                  }
                  @case (1) {
                    <span>Counter</span>
                  }
                  @case (2) {
                    <span>Average</span>
                  }
                }
              </div>
            </td>
            <td>{{row.datatype}}</td>
            <td>{{row.length}}</td>
            <td>
              <button type="button" mat-raised-button color="primary" (click)="onQueryClick(row)"><mat-icon>sync</mat-icon> Query device</button>
            </td>
            <td>
              @if (row.value) {
                <span class="fw-bold">{{(row.value*row.multiplier)+row.constoffset|number:'1.0-2'}} {{row.unit}}</span>
              }
            </td>
            <td>
              <mat-slide-toggle (toggleChange)="onLoggingChange(row)" [checked]="row.loggingEnabled" [(ngModel)]="row.loggingEnabled">Logging</mat-slide-toggle>
            </td>
            <td>
              <button type="button" mat-raised-button color="primary" (click)="onClickMeasure(row)">Edit</button>
              @if (idx+1 == measures.length) {
                <button type="button" mat-raised-button color="warn" class="ms-2" (click)="onClickMeasureDelete(row)">Delete</button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>

